import React from "react";

export const TitlePage = ({title, smallName}) => {
  return (<h1>
    {title}
    {smallName ? <small>{smallName}</small> : ''}
  </h1>);

}



// WEBPACK FOOTER //
// ./src/component/Page/Title.js